import { jsonMember, jsonObject } from 'typedjson';

@jsonObject()
export class ActiveSubscription {
    @jsonMember(String)
    _id: string;
    @jsonMember(String)
    userId: string;
    @jsonMember(String)
    planId: string;
    @jsonMember(Number)
    availableAppointments: number;
    @jsonMember(Number)
    consumedAppointments: number;
    @jsonMember(Number)
    totalAppointments: number;
    @jsonMember(String)
    trialEndDate: string;
    @jsonMember(String)
    stripeSubscriptionStatus: string;
    @jsonMember(String)
    startDate: string;
    @jsonMember(String)
    endDate: string;

    @jsonMember(Boolean)
    isActive: boolean;
    //
    // isPaymentCompleted: boolean;
    // createdAt: string;
    // updatedAt: string;
    // startDate: string;
    // endDate: string;
    // lastPaymentSuccessfulAt: string;
    // setupIntentClientSecret: string;
    // stripeSubscriptionId: string;
    // stripeSubscriptionStatus: string;
    // stripeInvoiceId: string;
    // stripeEvents: string[];
    // __v: number;
}
